import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Container } from '@mui/material';
import { Assignment as AssignmentIcon, PendingActions as PendingActionsIcon, EventBusy as EventBusyIcon, EventAvailable as EventAvailableIcon, CalendarMonth as CalendarIcon } from "@mui/icons-material";
import { getData } from "../../services/axiosInstance";
import { API_ENDPOINTS } from "../../services/endpoints";
import PushNotificationManager from "../../services/PushNotificationManager";
import Loader from "../../common/spinner";
import DashboardCard from "../../components/common/DashboardCard";

function EmployeeDashboard() {
    const navigate = useNavigate();
    const [stats, setStats] = useState({});
    const userDataRaw = localStorage.getItem('userData');
    const userData = userDataRaw ? JSON.parse(userDataRaw) : null;
    const userId = userData?.id;
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            if (!userId) return;
            setLoading(true);

            try {
                const url = `${API_ENDPOINTS.getEmployeeDashboardCounts}?userId=${userId}`;
                const res = await getData(url);

                if (res.status === "SUCCESS") {
                    setStats(res.message?.data || {});
                }
            } catch (e) {
                return null;
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, [userId]);

    const cards = [
        {
            id: 1,
            icon: <AssignmentIcon />,
            title: "Total Projects",
            count: stats.totalProjects || 0,
            p: "#243B55", s: "#141E30",
            path: "/employee/my-project-list"
        },
        {
            id: 2,
            icon: <PendingActionsIcon />,
            title: "Active Tasks",
            count: stats.totalIncompleteTasks || 0,
            p: "#6a11cb", s: "#2575fc",
            path: "/employee/my-tasks"
        },
        {
            id: 3,
            icon: <EventAvailableIcon />,
            title: "Monthly Attendance",
            count: stats.monthlyAttendancePercentage
                ? `${parseFloat(stats.monthlyAttendancePercentage)}%`
                : "0%",
            p: "#11998e", s: "#38ef7d",
            path: "/employee/my-attendance"
        },
        {
            id: 4,
            icon: <EventBusyIcon />,
            title: "Leave Balance",
            count: stats.totalLeaveBalance || 0,
            p: "#f093fb", s: "#f5576c",
            path: "/employee/manage-leave-requests",
            dialog: "Leave Balance"
        },
        {
            id: 5,
            icon: <CalendarIcon />,
            title: "Upcoming Holiday",
            // We store the name in 'count' and the date in a new property 'date'
            count: stats.upcomingHolidays?.[0]?.holiday_name || "None",
            date: stats.upcomingHolidays?.[0]?.date
                ? new Date(stats.upcomingHolidays[0].date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short' })
                : "",
            p: "#FF8C00", s: "#FFA500",
            path: "/employee/manage-leave-requests",
            dialog: "Holidays List"
        }
    ];

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                <Loader />
            </Box>
        );
    }

    return (
        <Box sx={{ p: 1 }}>
            <PushNotificationManager userId={userId} />
            <Container maxWidth="xl" sx={{ padding: '20px 0 !important' }}>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {cards.map(c => (
                        <Grid key={c.id} size={{ xs: 2, sm: 4, md: 4 }}>
                            <DashboardCard
                                card={c}
                                onClick={() => c.path && navigate(c.path, { state: { openDialog: c.dialog ?? null } })}
                            />
                        </Grid>
                    ))}
                </Grid>
            </Container >
        </Box>
    );
}

export default EmployeeDashboard;